var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { busService } from "../../bus";
import { StartSTTRecordMessage, StopSTTRecordMessage, STTAnnotationAnswerMessage, STTAnnotationRequestMessage, STTEditAnnotationInDialogRequestMessage } from "@messages/stt/STTMessages";
import { cutIntoLines, UTILITY_ROOM_UID } from "flavr-common";
import { useExternalMessages, modelPool } from "@modules/model";
const connection = busService.connection("ScriptSTT");
export class ScriptSTT {
    static startSTT() {
        const messages = [];
        const utilityRoom = modelPool.getModelOrThrow(UTILITY_ROOM_UID);
        const currentChildModel = modelPool.createModel(`SpeechToText_${Date.now()}`, utilityRoom, useExternalMessages(messages));
        messages.push(new StartSTTRecordMessage(currentChildModel.getUID()));
        connection.sendMultiple(messages);
    }
    static stopSTT() {
        connection.send(new StopSTTRecordMessage());
    }
    static getResultSTT() {
        return __awaiter(this, void 0, void 0, function* () {
            const msg = yield connection.askByMessageType(new STTAnnotationRequestMessage(), STTAnnotationAnswerMessage);
            return msg.result;
        });
    }
    static editAnnotationInDialog(currentAnnotation) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const reformattedAnnotation = currentAnnotation.replace(/\n/g, " ");
                const msg = yield connection.askByMessageType(new STTEditAnnotationInDialogRequestMessage(reformattedAnnotation), STTAnnotationAnswerMessage);
                msg.result = msg.result.replace(/\n/g, " ");
                return cutIntoLines(msg.result, 32);
            }
            catch (e) {
                console.error("Error in ScriptSTT.editAnnotationInDialog()", e);
                return currentAnnotation;
            }
        });
    }
}
